export default __webpack_public_path__ + "static/media/content-verified.6d739a97.svg";